import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksCheckInput, { InputType } from './BooksCheckInput';

import css from './BooksPaymentCard.module.scss';

interface Props extends React.ComponentProps<'input'> {
  className?: string;
  tailDigits: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksPaymentCard = ({
  className,
  tailDigits,
  intl,
  onChange,
  ...attr
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksPaymentCard, className);

  return (
    <div className={classes}>
      <BooksCheckInput
        {...attr}
        type={InputType.Radio}
        name="payment-creditcard"
        onChange={onChange}
      >
        {intl.formatMessage({ id: 'books.paymentMethod.history' })}
        <span className={css.BooksPaymentCard__Card}>
          <span className={css.BooksPaymentCard__Mask}>•••• •••• •••• </span>
          {tailDigits}
        </span>
      </BooksCheckInput>
    </div>
  );
};

export default injectIntl(BooksPaymentCard);
